import { ITransformer } from './types';
import { ICHCancelCheckout } from '../interfaces/operations';
import { ICancelCheckOut } from '@wk/elm-uui-doc-component';
import 'reflect-metadata';
import { injectable } from 'inversify';

@injectable()
export class CtxCancelCheckOutTransformer implements ITransformer {
    data!: ICHCancelCheckout;

    transform(): ICancelCheckOut {
        const nodeObj = {} as ICancelCheckOut;
        nodeObj.docId = this.data.documentId;
        nodeObj.entityContext = {
            name: this.data?.associatedEntityName || '',
            id: this.data?.associatedEntityId,
            type: this.data?.associatedEntityType,
        };
        nodeObj.extendedProps = {};
        nodeObj.extendedProps.loggedInUser = this.data?.loggedInUser;
        return nodeObj;
    }
}
